import "./Footer.css";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <h3>Kyra Renov</h3>

                        <p>
                            Rénovation intérieure et extérieure
                            en Île-de-France. Des projets réalisés
                            avec soin, exigence et
                            professionnalisme.
                        </p>
                    </div>

                    <div className="footer-links">
                        <h4>Navigation</h4>

                        <a href="/#hero">
                            Accueil
                        </a>

                        <a href="/#about">
                            À propos
                        </a>

                        <a href="/#realisations">
                            Réalisations
                        </a>

                        <a href="/#avant-apres">
                            Avant / Après
                        </a>

                        <a href="/#services">
                            Services
                        </a>

                        <a href="/#contact">
                            Contact
                        </a>
                    </div>

                    <div className="footer-contact">
                        <h4>Contact</h4>

                        <a href="tel:+33766138777">
                            07 66 13 87 77
                        </a>

                        <p>Île-de-France</p>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>
                        © {new Date().getFullYear()} Kyra
                        Renov. Tous droits réservés.
                    </p>
                </div>
            </div>
        </footer>
    );
}